import { CART1025CintCollGroupId } from "respondent_config_generator/src/projects/CART-1025";
import { PlatformInstructionsKey } from "../../LandingPage/Components/Steps/LoginAndCompletionCode";
import { LandingPageConfigBuilder } from "../../LandingPage/landingPageConfigBuilder";
import { CAIParams } from "../../queryParams";
import { setCurrentLang } from "../../i18n";
import { AppLanguage, getLanguageStrings } from "internationalisation";

const getPlatform = (groupId: CART1025CintCollGroupId): PlatformInstructionsKey => {
	switch (groupId) {
		case 'CART-460-1025-AU-WOOLWORTHS-DIGITAL':
			return "woolworths";
		default:
			assertNever(groupId);
	}
}

export const configureCART1025Page = (
	landingPagebuilder: LandingPageConfigBuilder,
	params: CAIParams<CART1025CintCollGroupId>
) => {
	setCurrentLang(AppLanguage.en);

	landingPagebuilder.setSteps(
		LandingPageConfigBuilder.getStandardViewingSurveySteps(
			getPlatform(params.G)
		)
	);

	landingPagebuilder.setPageTitle(
		getLanguageStrings(AppLanguage.en).LandingPage.Title
	);
}